import { render, staticRenderFns } from "./RemoveFacebookCampaignDialog.vue?vue&type=template&id=44a5fa1c"
import script from "./RemoveFacebookCampaignDialog.vue?vue&type=script&lang=js"
export * from "./RemoveFacebookCampaignDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports